import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import {Container} from 'react-bootstrap'
import {Form} from 'react-bootstrap'
import {Button} from 'react-bootstrap'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


export default function NewTable(props) {
        
  const { register, handleSubmit, errors } = useForm();
  const [validated, setValidated] = useState(false);
  const [customError, thisError] = useState("")

  const onSubmit = (data, event, errors) => {
    event.preventDefault();
    const form = event.target;

    if (form.checkValidity() === false) {
        thisError("Check for required fields")
        event.stopPropagation();
        // console.log("Data Errors: ", data);
    } else {
        // console.log("Data OK: ", data);
        thisError("")
        setValidated(true);
        props.tableSubmit()
    }
    
  }

  return (
    <Container className="tableForm">
       <h3>New Cupping Table by {props.CatadorName}</h3> <br></br>
       <h4><b>Table Details</b></h4> 
     
     <Form onSubmit={handleSubmit(onSubmit)} validated={validated} noValidate> 
        <Form.Group controlId="formBasicDate">
            <Form.Label>Cupping Date</Form.Label> <br></br>
            <DatePicker
                name="date"
                onChange={props.handleDate}
                selected={props.date}
                maxLength="11"
                placeholder="Cupping Date" 
                ref={register({required: true, maxLength: 12, name: "date", value: props.date})}
                required
            />
            <span className="invalid">
                {customError ? customError : null}
            </span> 
        </Form.Group>
        <Form.Group controlId="formBasicTextF" >
            <Form.Label>Cupping Table Name</Form.Label>
            <Form.Control type="text" value={props.tname} onChange={props.handlechange} onBlur={props.trimInput} placeholder="Enter Name" minLength="4" maxLength="80" name="tname" ref={register({required: true, minLength: 4, maxLength: 81})} required/>    
                <span className="invalid">
                {errors.tname && errors.tname.type === "minLength" && "Please make sure name is at least 4 characters."}
                {errors.tname && errors.tname.type === "required" && "Name is required"} 
                </span> 
            <Form.Text className="text-muted"> 
                Name must be at least 4 characters. 
            </Form.Text>
        </Form.Group>
        <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>Table Description</Form.Label>
                <Form.Control as="textarea" value={props.tdescription} onChange={props.handlechange} onBlur={props.trimInput} rows="3" maxLength="500" placeholder="Enter Description" name="tdescription" ref={register({required: true, minLength: 1, maxLength: 501})} required/>
                    <span className="invalid">
                    {errors.tdescription && errors.tdescription.type === "minLength" && "Please make sure description is at least 1 character."}
                    {errors.description && errors.description.type === "maxLength" && "Description length max 500 characters"}
                     {errors.tdescription && errors.tdescription.type === "required" && "Description is required"} 
                    </span> 
                <Form.Text className="text-muted"> 
                    Describe your table with at least 4 characters.
                </Form.Text>
                
        </Form.Group>

        <Form.Group controlId="formBasicRange">
            <Form.Label>Sample Size</Form.Label> <br></br>
            <input type="range" className="numCupRange" placeholder="Number of Coffees" onChange={props.handlechange} name="cuppingNum" defaultValue="1" max="15" min="1" ref={register({required: true, max: 15, min: 1})} /> <span>{props.cuppingNum}</span>
            <Form.Text className="text-muted">
                Number of coffees to be cupped. 
            </Form.Text>
        </Form.Group>
        <Form.Group >
        <Form.Check 
            type="switch"
            id="custom-switch"
            label="Specialty Baseline (Default)"
            name="specialtyDefaults"
            defaultChecked={true}
            onChange={props.handleSwitch}
            ref={register({required: false})} 
        />
        <Form.Text className="text-muted">
            Clean cup, uniformity and sweethness will be scored to 10 each. 
        </Form.Text>
         </Form.Group>
         <Form.Group>
        <Form.Check 
              type="switch"
              id="custom-switch2"
              label="Share Cupping with the Community!"
              name="publicCupping"
              defaultChecked={true}
              onChange={props.handleSwitch}
              ref={register({required: false})} 

        />
         </Form.Group>
        
        <Button variant="primary" type="submit">
            <span className="emoji" role="img" aria-label="rocket_coffee"> 🚀 Start Cupping! ☕️ </span>
        </Button>
        </Form>
        </Container>
  );
}